<div class="alignment tool-box">
    <h5 class="title">
        {{ 'mimic-drawing.alignment' | translate }}
    </h5>
    <div class="alignment-list tool-list">
        <div
            class="icon-wrapper"
            [matTooltip]="alignTool.tooltip | translate"
            *ngFor="let alignTool of ALIGN_TOOL_LIST; index as i"
            [class.disabled]="optionsAreDisabled()"
            (click)="alignElements(alignTool)">
            <mat-icon class="icon" [svgIcon]="alignTool.svgIcon"></mat-icon>
        </div>
    </div>
</div>
